import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PassValLibComponent } from './pass-val-lib.component';



@NgModule({
  declarations: [
    PassValLibComponent
  ],
  imports: [
    FormsModule
  ],
  exports: [
    PassValLibComponent
  ]
})
export class PassValLibModule { }
